<h1 class="title">Contacts</h1>
<h5>&nbsp;</h5>
<acabim-datatable
    #dataTable
    [dataSources]="[this]"
    [dataKey]="'id'"
    (_editForm)="getEditForm($event)"
    hasDetailView="true">
</acabim-datatable>
<div class="cas-action-buttons">
    <!--        <button type='button' (click)="click()">Add</button>-->
    <button
            type='button'
            (click)="addContactCall()"
            class="cas-button-action"
            data-cy="_t-add-contact">Add</button>
</div>

<acabim-card cardHeading="Import a list of users (*.csv)"
     [cardContent]="ImportUsers"
     [isCollapsible]="true"
     [isCollapsed]="true"
     [hasHelpButton]="true"
     [helpMessage]="'Upload a CSV file with a column header containing a list of people into the system. Drop your file into the box and click the START button when ready and you will get a chance to map your data to the right columns'"
></acabim-card>

<acabim-card cardHeading="Import a list of contacts (*.csv)"
             [cardContent]="ImportContacts"
             [isCollapsible]="true"
             [isCollapsed]="true"
             [hasHelpButton]="true"
             [helpMessage]="'Upload a CSV file with a column header containing a list of people into the system. Drop your file into the box and click the START button when ready and you will get a chance to map your data to the right columns'"
></acabim-card>

<ng-template #ImportUsers>
    <acabim-admin-import-users></acabim-admin-import-users>
</ng-template>

<ng-template #ImportContacts>
    <acabim-admin-import-contacts></acabim-admin-import-contacts>
</ng-template>

<p-dialog
        [(visible)]="delete"
        header="Confirm Delete Contacts"
        baseZIndex="1100"
        [modal]="true"
        [style]="{width: '50vw'}"
        [dismissableMask]="false">
    <ng-template pTemplate="content">
        <acabim-admin-confirm-delete-modal
                *ngIf="delete"
                [deleteData]="selectedData"
                [columnData]="columnData"
                (out)="deleteAction($event)">
        </acabim-admin-confirm-delete-modal>
    </ng-template>
</p-dialog>
<ng-template #loadingView>
    <acabim-loading-view></acabim-loading-view>
</ng-template>

<ng-container *ngIf="addContact">
    <acabim-modal
        [title]="'Add a new contact'"
        [display]="addContact"
        [footer]="false"
        fixHeight="80vh"
        (status)="toggleAddContactModal($event)">
        <acabim-admin-add-contact *ngIf="addContact" (submit)="submit($event)"></acabim-admin-add-contact>
    </acabim-modal>
</ng-container>

<ng-container *ngIf="showDetails">
    <acabim-modal
        [title]="'Contact details'"
        [display]="showDetails"
        [footer]="false"
        (status)="toggleDetailsModal($event)"
        fixHeight="80vh">
        <acabim-admin-contact-detail
            *ngIf="showDetails"
            [contactID]="detailData?.id"
            [detailData]="detailData"
            [columnData]="columnData"
            (updateForm)="getEditForm($event)"
            (updateFile)="updateFile($event)"
            (removeFile)="removeFile($event)">
        </acabim-admin-contact-detail>
    </acabim-modal>
</ng-container>

<ng-container *ngIf="showError">
    <acabim-modal
        [title]="'Error Message'"
        [display]="showError"
        [footer]="false"
        (status)="toggleErrorForm($event)">
        <div *ngIf="errorMessage">
            <b> {{ errorMessage ? errorMessage.message : ''}}</b>
            <p><b>Contact ID:</b> {{ errorMessage ? errorMessage.data.id : ''}}</p>
            <p><b>Name:</b> {{  errorMessage ? errorMessage.data.user_name : ''}}</p>
        </div>
    </acabim-modal>
</ng-container>
<p-toast position="center"></p-toast>
